import React, { useState, useEffect } from 'react'
import axios from 'axios';
import DropDown from './DropDown';
import { FileUploader } from "react-drag-drop-files";
export default function Projectpop(props) {
    const [resend, setResend] = useState(false);
    const submitting = () => {
        setResend(resend ? false : true);
    }
    const [error, setError] = useState('')
    const [details, setDetails] = useState(props.path == 'projects' ? props.data ? props.data : {
        project_name: "",
        no_of_resources: "",
        project_location: "",
        approx_duration: "",
        approx_start_date: "",
        customer: "",
        information_for_hr: "",
        max_pay_out: "",
        specififcation: "",
        status: "OPEN",
        client_approved_coast: "",
        additional_detailes: "",
        flyaxavi_approved_coast: "",
        project_members: "",
        currency: '₹'
    }
        : props.path == 'agreements' ? {
            currency: localStorage.getItem('selectedCurrency')

        } : {
            consultant: "",
            Agree_fee: "",
            Normal_fee: "",
            till_project: "",
            description: "",
            assaigned_project_name: "",
            travel: "",
            accomendation: "",
            currency: localStorage.getItem('selectedCurrency'),
        });
    const d = new Date();
    const post = async e => {

        function monthDiff(d1, d2) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        }
        e.preventDefault();
        details.approx_duration = await parseInt(monthDiff(new Date(details.approx_start_date), new Date(details.approx_duration)))
        var bodyFormData = new FormData();
        if (props.path == 'projects') {
            bodyFormData.append('project_name', details.project_name)
            bodyFormData.append('no_of_resources', details.no_of_resources)
            bodyFormData.append('project_location', details.project_location)
            bodyFormData.append('approx_duration', details.approx_duration)
            bodyFormData.append('approx_start_date', details.approx_start_date)
            bodyFormData.append('customer', details.customer)
            bodyFormData.append('information_for_hr', details.information_for_hr)
            bodyFormData.append('max_pay_out', details.max_pay_out)
            // bodyFormData.append('max_pay_out', parseFloat((details.max_pay_out * currency[details.currency]).toFixed(2)))
            let specs = document.getElementsByName('SpecNames');
            let valuesf=[]
            for(let i=0;i<2;i++)
                if (specs[i].checked)valuesf.push(specs[i].value)
            if (showO) valuesf.push(document.getElementById('privSpec').value);
            console.log(valuesf)
            bodyFormData.append('specififcation', valuesf.join(', '))
            bodyFormData.append('status', details.status)
            bodyFormData.append('currency', details.currency)
            bodyFormData.append('project_members', values.map(e => e.id).join(','))
            bodyFormData.append('client_approved_coast', details.client_approved_coast)
            // bodyFormData.append('client_approved_coast', parseFloat((details.client_approved_coast * currency[details.currency]).toFixed(2)))
            bodyFormData.append('additional_detailes', details.additional_detailes)
            bodyFormData.append('additional_detailes', details.additional_detailes)
            bodyFormData.append('flyaxavi_approved_coast', details.flyaxavi_approved_coast)
            // bodyFormData.append('flyaxavi_approved_coast', parseFloat((details.flyaxavi_approved_coast * currency[details.currency]).toFixed(2)))
        }
        else if (props.path == 'contracts') {
            bodyFormData.append('consultant', document.getElementById('userdrop').value)
            bodyFormData.append('Agree_fee', details.Agree_fee)
            bodyFormData.append('currency', details.currency)
            // bodyFormData.append('Agree_fee', parseFloat((details.Agree_fee * currency[details.currency]).toFixed(2)))
            bodyFormData.append('Normal_fee', details.Normal_fee)
            // bodyFormData.append('Normal_fee', parseFloat((details.Normal_fee * currency[details.currency]).toFixed(2)))
            bodyFormData.append('till_project', details.till_project)
            bodyFormData.append('assaigned_project', document.getElementById('projdrop').value)
            bodyFormData.append('description', details.description)
            bodyFormData.append('travel', document.getElementById('yes').checked ? 'True' : 'False')
            bodyFormData.append('accomendation', document.getElementById('ayes').checked ? 'True' : 'False')
        } else {
            bodyFormData.append('user', document.getElementById('userdrop').value)
            bodyFormData.append('file', file)
        }
        let notify = document.getElementsByClassName('noti')[0];

        if (props.path == 'projects') {
            if (props.data) {
                // bodyFormData.append('slug', details.slug)
                for (var pair of bodyFormData.entries()) {
                    console.log(pair[0] + ', ' + typeof pair[1]);
                }
                await axios({
                    method: "put",
                    url: `${process.env.REACT_APP_API_URL1}/project/projects/${details.slug}/`,
                    data: bodyFormData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    },
                }).then(response => {
                    document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                    props.call(false)
                    notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                            ${response.data.message}, hit Refresh button
                        </div>`;
                    setTimeout(() => {
                        notify.removeChild(notify.lastChild)
                    }, 3000);
                    console.log(response)
                    // console.lof(details)
                }).catch(err => {
                    console.log(err)
                    notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                            ${err.response.data.message}
                        </div>`;
                    setTimeout(() => {
                        notify.removeChild(notify.lastChild)
                    }, 3000);
                    // props.call()
                    console.log(notify)
                    console.log(details)
                })
            } else {
                await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL1}/project/projects/`,
                    data: bodyFormData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    },
                }).then(response => {
                    document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                    props.call(false)
                    console.log(response)
                    notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                            ${response.data.message}, hit Refresh button
                        </div>`;
                    setTimeout(() => {
                        notify.removeChild(notify.lastChild)
                    }, 3000);
                    setDetails({
                        project_name: "",
                        no_of_resources: "",
                        project_location: "",
                        approx_duration: "",
                        approx_start_date: "",
                        customer: "",
                        information_for_hr: "",
                        max_pay_out: "",
                        specififcation: "",
                        status: "OPEN",
                        client_approved_coast: "",
                        additional_detailes: "",
                        flyaxavi_approved_coast: "",
                        project_members: "",
                        currency: '₹'
                    })
                }).catch(err => {
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                            ${err.response.data.message}</div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                    // props.call()
                    console.log(err)
                    console.log(details)
                })
            }
        }
        else if (props.path == 'contracts') {
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/hr/contract/`,
                data: bodyFormData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(response => {
                document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                props.callBack.call(false)
                console.log(response)
                notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                        ${response.data.message}, hit Refresh button
                    </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
            }).catch(err => {
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        ${err.response.data.message}
                    </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
                console.log(details)
            })
        } else {
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/hr/agreement/`,
                data: bodyFormData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(response => {
                document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                props.call(false)
                console.log(response)
                notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                        ${response.data.message}, hit Refresh button
                    </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
            }).catch(err => {
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        ${err.response.data.message}
                    </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
                console.log(details)
            })

        }
        console.log('submitted')

        console.log(sOptions)
    }

    // const post=(e)=>{ e.preventDefault();;console.log()}
    const handleCallback = (childData) => {
        setSoptions(childData)
    }
    const [sOptions, setSoptions] = useState([])
    const fileTypes = ["PDF"];
    const [file, setFile] = useState(null);
    const handleChange = (file) => {
        setFile(file);
    };
    // props.data?setDetails(props.data):console.log(details)
    let currency = JSON.parse(localStorage.getItem('currency'))
    useEffect(async () => {
        console.log(details)
        await axios.get(`${process.env.REACT_APP_API_URL1}/hr/user_module/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                console.log(response.data)
                let option = []
                await response.data.map((e) => {
                    console.log(currency)
                    console.log(details.currency)
                    if (e.id != null) option.push({ id: e.id, user_id: e.user_id, key: e.id, name: e.first_name + ' ' + e.last_name })
                    if (props.path == 'contracts' || props.path == 'agreements')
                        document.getElementById('userdrop').innerHTML += `<option key=${e.id} value=${e.id}>${e.user_id + ' ' + e.first_name + ' ' + e.last_name}</option>`
                    // try {
                    //     if (e.Get_detailes.id != null) document.getElementsByClassName('myprojmemlist')[0].innerHTML +=
                    //         `<span><input type='checkbox' name='spmcheck' id='${e.Get_detailes.id}' value='${e.Get_detailes.id}'/>
                    //         <label for='${e.Get_detailes.id}'>${e.user_id +' '+e.first_name + ' ' + e.last_name}</label></span>`
                    // }
                    // catch (e) { console.log(e) }
                })
                setOptions(option)
                console.log(option)
                console.log(options)
            }).catch(err => {
                console.log(err)
            })
    }, [])
    const [options, setOptions] = useState([])
    var curcur = localStorage.getItem('selectedCurrency')
    let countries = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
        "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
        "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
        "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad",
        "Chile", "China", "Colombi", "Comoros", "Congo (Brazzaville)", "Congo", "Costa Rica", "Cote d'Ivoire", "Croatia",
        "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor (Timor Timur)",
        "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France",
        "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
        "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
        "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait",
        "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
        "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
        "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar", "Namibia",
        "Nauru", "Nepa", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau",
        "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
        "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe",
        "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
        "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
        "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
        "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
        "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"]
    useEffect(() => {
        if (props.data) {
            let data = props.data;
            console.log(data)
            const addDays = function (days) {
                var date = new Date(data.approx_start_date);
                date.setDate(date.getDate() + days);
                return date;
            }
            let optioner = []
            props.data.project_mebers.map(e => {
                optioner.push({ id: e.id, key: e.id, user_id: e.user_id, name: e.first_name + ' ' + e.last_name })
                // document.getElementById(e.id).checked = true
            })
            setVal(optioner)
            data.currency = '₹'
            // data.client_approved_coast = (data.client_approved_coast / currency[curcur]).toFixed(2);
            // data.max_pay_out = (data.max_pay_out / currency[curcur]).toFixed(2);
            let date = addDays(data.approx_duration * 30);
            // data.approx_start_date=new Date(data.approx_start_date)
            data.approx_duration = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1));
            setDetails(data)
            // console.log(data)
        } else {
            setDetails({
                project_name: "",
                no_of_resources: "",
                project_location: "",
                approx_duration: "",
                approx_start_date: "",
                customer: "",
                information_for_hr: "",
                max_pay_out: "",
                specififcation: "",
                status: "OPEN",
                client_approved_coast: "",
                additional_detailes: "",
                flyaxavi_approved_coast: "",
                project_members: "",
                currency: '₹'
            })
            setVal([]);
            setOptions([]);
            // let divs = document.getElementsByClassName('myDropdownSingle')[0].getElementsByTagName('input');
            // for(let  i of divs){
            //     i.checked=false;
            // }
        }
    }, [props.data])
    const [values, setVal] = useState(null)
    const [showO, setSo] = useState(false)
    return (
        <div className='projDetI'>
            <div className="projright">
                <i onClick={() =>
                    document.getElementsByClassName('showdet')[0].classList.remove('show_hide')
                } class="fas fa-times"></i>{props.path == 'projects' ? 'PROJECT DETAILS' : props.path != 'agreements' ? 'CONTRACT DETAILS' : 'AGREEMENT DETAILS'}<br /><br /></div>
            <form encType="multipart/form-data" id='myform' onSubmit={post}>
                <div className='form-inner'>
                    {(error !== "") ? <div className='error'>{error}</div> : ""}
                    {props.path == 'projects' ? <table>
                        <tr>
                            <td><input name='ider' type="text" placeholder='Project Name' onChange={e => { setDetails({ ...details, project_name: e.target.value }) }} value={details.project_name} /></td>
                            <td>
                                <input type="number" placeholder='Number of Resources' onChange={e => { setDetails({ ...details, no_of_resources: parseInt(e.target.value ? e.target.value : 0) }) }} value={details.no_of_resources} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {/* <input type="text" placeholder='Project Location' onChange={e => { setDetails({ ...details, project_location: e.target.value }) }} value={details.project_location} /> */}
                                <select className='CSel' style={{marginLeft:'20px',marginTop:'5px',height:'45px'}}  onChange={e => { setDetails({ ...details, project_location: e.target.value }) }}  id='country' >
                                    <option value='none'> Select Country </option>
                                    <option value='India'> India </option>
                                    {
                                        Object.keys(countries).map((item) => (
                                            <option value={countries[item]}> {countries[item]} </option>
                                        ))
                                    }
                                </select>
                            </td>
                            <td>
                                <div className='row' style={{ marginLeft: '20px' }}>
                                    {/* <input type="number"placeholder='From' onChange={e => { setDetails({ ...details, from: e.target.value }) }} value={details.from} /> */}
                                    <input className='nomargin'
                                        // min={d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()} 
                                        onChange={e => { setDetails({ ...details, approx_start_date: e.target.value }) }} style={{ width: '100%' }}
                                        value={details.approx_start_date} type='date' name='datt' />
                                    <span style={{ marginLeft: '10px', marginRight: '10px', fontSize: '14px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', justifyContent: 'center' }} for='date'> to </span>
                                    <input className='nomargin' type="month" id='duedate'
                                        // min={d.getFullYear() + '-' + (d.getMonth() + 1)}
                                        value={details.approx_duration}
                                        placeholder='due' onChange={e => { setDetails({ ...details, approx_duration: e.target.value }) }} />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><input type="text" placeholder='Customer / Vendor' onChange={e => { setDetails({ ...details, customer: e.target.value }) }} value={details.customer} /></td>
                            <td><input type="text" placeholder='Info for HR' onChange={e => { setDetails({ ...details, information_for_hr: e.target.value }) }} value={details.information_for_hr} /></td>

                        </tr>
                        {/* <span><CurrencyConverter className="form-control" from={'USD'} to={'INR'} value={1}/></span> */}
                        <tr>
                            <td>
                                <input type="text" placeholder='Flyxavi Approved Cost' onChange={e => { setDetails({ ...details, flyaxavi_approved_coast: parseInt(e.target.value ? e.target.value : 0) }) }} value={details.flyaxavi_approved_coast} />

                                {/* <input type="text" placeholder='Specification' onChange={e => { setDetails({ ...details, specififcation: e.target.value }) }} value={details.specififcation} /> */}
                            </td>
                            <td><input type="number" placeholder='Candidate max payment' onChange={e => { setDetails({ ...details, max_pay_out: parseInt(e.target.value ? e.target.value : 0) }) }} value={details.max_pay_out} /></td>
                        </tr>
                        <tr>
                            <td rowSpan={2}><textarea type="text" placeholder='Additional Details' onChange={e => { setDetails({ ...details, additional_detailes: e.target.value }) }} value={details.additional_detailes} /></td>
                            <td>
                                <input type="number" placeholder='Client Approval Cost' onChange={e => { setDetails({ ...details, client_approved_coast: parseInt(e.target.value ? e.target.value : 0) }) }} value={details.client_approved_coast} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ marginLeft: '5%', fontSize: '20px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'initial' }} >Specification : </span><br /><br /><br /><br />
                                <span style={{ marginLeft: '5%', fontSize: '20px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'initial' }} >Currency : </span><br />
                                <span style={{ marginLeft: '5%', fontSize: '20px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'initial' }} > Status&emsp;:&emsp; </span>
                            </td>
                            <td className='setDwA' >
                                {/* <select onChange={(e) => { setDetails({ ...details, specififcation: e.target.value }); }} value={details.specififcation} id='specification'>
                                    <option value='records review'>records review</option>
                                    <option value='physical'>physical</option>
                                    <option value='other'>other</option> */}
                                <div className="row">
                                    <input type="checkbox" id='CRR' name="SpecNames" value="records review" />
                                    <label for='CRR'>Records Review</label></div>
                                <div className="row">
                                    <input type="checkbox" id='Cpy' name="SpecNames" value="physical" />
                                    <label for='Cpy'>Physical</label></div>
                                <div className="row">
                                    <input onChange={(e) => setSo(e.target.checked ? true : false)} type="checkbox" id='COi' name="SpecNames" value="others" />
                                    <label for='COi'>Others</label></div>
                                {showO ? <input id='privSpec' placeholder='Enter Specification' /> : <><br /><br /></>}
                                {/* </select> */}
                                <select onChange={(e) => { setDetails({ ...details, currency: e.target.value }); }} id='currency'>
                                    <option value='₹'>INR</option>
                                    <option value='$'>USD</option>
                                    <option value='€'>EUR</option>
                                    <option value='د.إ'>AED</option>
                                </select><br /><br />
                                <select value={details.status} style={{ fontSize: '17px', height: '40px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }} onChange={e => { setDetails({ ...details, status: e.target.value }) }}>
                                    <option value='OPEN'>OPEN</option>
                                    <option value='IN PROGRESS'>IN PROGRESS</option>
                                    <option value='CLOSED'>CLOSED</option>
                                </select>
                                {/* <input type="text" placeholder='Status' value={details.CName} /> */}
                            </td>
                        </tr>
                        {/* <tr> */}
                        {/* <input type="text" placeholder='Project Members' onChange={e => { setDetails({ ...details, project_members: e.target.value }) }} value={details.project_members} /> */}
                        {/* <Multiselect
                                    options={options} // Options to display in the dropdown
                                    selectedValues={val} // Preselected value to persist in dropdown
                                    onSelect={onSelect} // Function will trigger on select event
                                    onRemove={onRemove} // Function will trigger on remove event
                                    displayValue="name" // Property name to display in the dropdown options
                                /> */}
                        <DropDown
                            options={options}
                            values={values}
                            parentCallback={setVal}
                        />
                        {/* </tr> */}
                    </table> : props.path != 'agreements' ?



                        //contracts view
                        <table><br />
                            <tr className='newAl'>
                                <td><span style={{ color: 'white', fontSize: '18px' }}>Project Name : &ensp;</span><br /><br />
                                    <span style={{ color: 'white', fontSize: '18px' }}>Consultant Name : &ensp;</span><br /><br />
                                    <span style={{ color: 'white', fontSize: '18px' }}>Currency : </span>
                                </td>
                                <td>
                                    <select id='projdrop'>
                                    </select><br /><br />
                                    <select id='userdrop'>
                                    </select><br /><br />
                                    <select value={curcur} onChange={(e) => setDetails({ ...details, currency: e.target.value })} id='currency'>
                                        <option value='₹'>INR</option>
                                        <option value='$'>USD</option>
                                        <option value='€'>EUR</option>
                                        <option value='د.إ'>AED</option>
                                    </select>
                                </td>
                            </tr><br />
                            <tr>
                                <td className='radio'>
                                    Travel &ensp;:
                                    <input type="radio" id='yes' defaultChecked name="Travel" value="True" />
                                    <label for="yes">YES</label>
                                    <input type="radio" id='no' name="Travel" value="False" />
                                    <label for="no">NO</label>
                                </td>
                                <td className='radio'>
                                    Accommodation &ensp;:
                                    <input type="radio" id='ayes' defaultChecked name="accomodation" value="True" />
                                    <label for="ayes">YES</label>
                                    <input type="radio" id='ano' name="accomodation" value="False" />
                                    <label for="ano">NO</label>
                                </td>
                            </tr><br />
                            <tr>
                                <td><input type="number" placeholder='Normal Fee' onChange={e => { setDetails({ ...details, Normal_fee: e.target.value }) }} value={details.Normal_fee} /></td>
                                <td>
                                    <input type="number" placeholder='Agreed Fee' onChange={e => { setDetails({ ...details, Agree_fee: parseInt(e.target.value ? e.target.value : 0) }) }} value={details.Agree_fee} />
                                </td>
                            </tr><br />
                            <tr>
                                <td rowSpan={2}><textarea type="text" placeholder='Till Project' onChange={e => { setDetails({ ...details, till_project: e.target.value }) }} value={details.till_project} /></td>
                                <td rowSpan={2}><textarea type="text" placeholder='Description' onChange={e => { setDetails({ ...details, description: e.target.value }) }} value={details.description} /></td>
                            </tr>
                        </table> : <>
                            <table><br />
                                <tr> User :
                                    <select id='userdrop' style={{ fontSize: '17px', height: '40px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }} onChange={e => { setDetails({ ...details, name: e.target.value }) }}>
                                    </select>
                                </tr><br /><br />
                                <tr>
                                    File :
                                    <FileUploader children={
                                        <div className='drop-zone'>
                                            <p>Profile pic: Click to browse or <br />drag and drop your files{!file ? <><br />{fileTypes.join(', ')}</> : <></>}<br />{file ? `${file.name}` : ""}</p>
                                        </div>
                                    } handleChange={handleChange} name="file" types={fileTypes} />
                                </tr>
                            </table>
                        </>}
                    <div className="center">
                        <button type='submit' className='signupbutton'>SUBMIT</button>
                    </div>
                </div>
            </form>
        </div>
    )
}


/*
Project manager :
    1.projects :
        get:-   /hr/user_module/ to select project members
            -   /project/projects/ to fetch projects

        post:-   /project/projects/ to create project

    2.users : 
        get:-   /hr/user_module/ to fetch users

Accountant :
    1.projects :
        get:-   /project/projects/ to fetch projects

    2.invoices :
        get:-   /consultant/Invoice_module/ to fetch invoices

HR :
    1.projects :
        get :-  /project/projects/ to fetch projects
    
    2.contracts:
        get:-   /consultant/contract/ to fetch contracts
                /hr/user_module/     to select consultant user
                /project/projects/ to select project name
    3.agreements:
        get:-   /consultant/Agrrement_module/ to get agreements
        post:-   /hr/agreement/ to create agreement
    4.users : 
        get:-   /hr/user_module/ to fetch users

consultant:
    1.projects :
        get :-  /project/projects/ to fetch projects
    2.invoices :
        get:-   /consultant/Invoice_module/ to fetch invoices
                /project/projects/ to select project name
        post:-  /consultant/Invoice_module/ to create invoice
    3.contracts:
        get:-   /consultant/contract/ to fetch contracts
    4.agreements:
        get:-   /consultant/Agrrement_module/ to get agreements
*/